const foodmeal = {
  getlist: 'foodmeal/getlist',
  add: 'foodmeal/add',
  update: 'foodmeal/update',
  remove: 'foodmeal/remove',
  get: 'foodmeal/get',
  getall: 'foodmeal/getall',
}
export default foodmeal
